import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Setting } from '@easy-lib/modules/settings/models/settings.model';
import { BaseService } from '@easy-lib/modules/shared/services/Base/base.service';

export const DARK = 'colorize-dark';
export const LIGHT = 'colorize-light';
// export const DARK_HREF = "assets/css/colorize-dark.min.css";
// export const LIGHT_HREF = "assets/css/colorize-light.min.css";

@Injectable({
	providedIn: 'root'
})
export class SettingService extends BaseService {
	get(): Observable<Setting> {
		return this.httpService.get<Setting>(`${this.mtsPath + this.apiUrls.easy}clientAppSetting`);
	}
	update(setting: Setting): Observable<Setting> {
		return this.httpService.post<Setting>(`${this.mtsPath + this.apiUrls.easy}clientAppSetting`, {
			body: {
				settings: setting
			}
		});
	}
}
